module.exports = __webpack_public_path__ + "media/bundles/OrderRecap/GameCard/assets/banner-gamindo-mobile-219fca28a446edfcee9af01857f75b8f.png";